import { API_URL } from '../../../environment';
import { ducksActionCreator } from '../../ducksHelpers';

export const providerPayoutsSettings = {
  stateName: 'providerPayouts',
  dataType: 'object',
  actions: {
    fetch: 'ducks/provider_payouts/FETCH_PROVIDER_PAYOUTS',
  },
};

export function fetchProviderPayouts(
  page = 1,
  filters,
  callback = () => {},
  errorCallback = () => {},
) {
  const filterString = Object.keys(filters)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(filters[k])}`)
    .join('&');

  return ducksActionCreator(
    providerPayoutsSettings.actions.fetch,
    'get',
    `${API_URL}/admin/provider_payouts?page=${page}&${filterString}`,
    {},
    true,
    callback,
    errorCallback,
  );
}
